import * as React from "react";
import { useMutation } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { CANCEL_APPOINTMENT_BY_TOKEN } from "../../../../../../../queries/v3/pages/CancelAppointment/queries/cancel-appointment-by-token.js";
import { fromCancelAppointmentQueryToAppointment } from "../../../../../adapters/v3/pages/CancelAppointment/hooks/api/adapters/fromCancelAppointmentQueryToAppointment.js";
function isAppointment(result) {
  return result.__typename === "Appointment";
}
const useCancelAppointmentByToken = () => {
  const { locale } = useIntl();
  const [query, queryState] = useMutation(CANCEL_APPOINTMENT_BY_TOKEN, {
    context: {
      forwardHeaders: {
        "Accept-Language": locale
      },
      timeout: 3e4
    },
    onError: (error) => {
      console.error(`Error occurred while executing CANCEL_APPOINTMENT_BY_TOKEN query: `, error);
    }
  });
  const data = React.useMemo(() => {
    return queryState.data?.cancelAppointmentByToken && isAppointment(queryState.data?.cancelAppointmentByToken) ? fromCancelAppointmentQueryToAppointment(
      queryState.data.cancelAppointmentByToken
    ) : null;
  }, [queryState]);
  return React.useMemo(() => [query, { ...queryState, data }], [data, queryState, query]);
};
export {
  useCancelAppointmentByToken as default
};
//# sourceMappingURL=use-cancel-appointment-by-token.js.map
